import React from 'react'
import Image from '../images/faisalabad.jpg'

const Faisalabad = () => {
    return (
        <div className='cities'>
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        <div className="c_img">
                        <img src={Image} alt="Faisalabad" className='city_img' />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="cities_inner">
                        <h1>Faisalabad</h1>
                        <p>Lyallpur named after the founder of the city is the third-most-populous city in Pakistan after Karachi and Lahore respectively,
                             and the second-largest in the eastern province of Punjab. Historically one of the first planned cities within British India,
                              it has long since developed into a cosmopolitan metropolis. Faisalabad was restructured into city district status; a devolution
                               promulgated by the 2001 local government ordinance (LGO). The total area of Faisalabad District is 5,856 km2 (2,261 sq mi) while
                                the area controlled by the Faisalabad Development Authority (FDA) is 1,280 km2 (490 sq mi). Faisalabad has grown to become a major
                                 industrial and distribution centre because of its central location in the region and connecting roads, rails, and air transportation.
                                  It has been referred to as the "Manchester of Pakistan". As of 2013, GDP (PPP) of Faisalabad was estimated as $43 billion and projected
                                   to rise to $87 billion in 2025 at a growth rate of 5.7%. Faisalabad contributes over 10 percent to the Punjab's GDP and has an average
                                    annual GDP (nominal) of $20.5 billion. Agriculture and industry remain its hallmark.</p>
                                     </div>
                    </div>
                </div>
            </div>
            
        </div>
    )
}

export default Faisalabad
